import script from "./Risk.vue?vue&type=script&setup=true&lang=js"
export * from "./Risk.vue?vue&type=script&setup=true&lang=js"

import "./Risk.vue?vue&type=style&index=0&id=28259836&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28259836"]])

export default __exports__